import React from 'react';
import { Table, Alert, Input, Button, Collapse } from 'reactstrap';

const Product = ({
  product,
  editData,
  editMode,
  currentId,
  groupId,
  productIndex,
  updateProductField,
  onFieldProductPriceUpdate,
  deleteProduct,
  indexOpen,
  onToggleCollapse,
}) => {
  const onChangePrice = (e, key) => {
    const { value } = e.currentTarget;
    let price = value;
    if (price.length >= 2 && price[0] === '0' && price[1] !== '.') {
      price = price.substring(1);
    }
    const rx = /^(\d+\.\d{1,2})|(\d+?\.|\d+|\s*)/;
    const match = price.match(rx);
    price = match[0];
    onFieldProductPriceUpdate(productIndex, key, price);
  };

  const onBlurPrice = (e, key) => {
    const { value } = e.target;
    let price = value;
    if (parseFloat(price) <= 0 || isNaN(parseFloat(price))) {
      price = '0';
    } else {
      price = parseFloat(value).toFixed(2);
    }
    onFieldProductPriceUpdate(productIndex, key, price);
  };

  return (
    <div className="product-groups-item">
      {editMode && currentId === groupId && (
        <>
          <div className="edit-name-product-container">
            <Input
              className="edit-input-product"
              name="name"
              value={editData.products[productIndex].name}
              placeholder="Please enter product name"
              onChange={e =>
                updateProductField(productIndex, e.currentTarget.name, e.currentTarget.value)
              }
            />
          </div>
          <div className="action-accordion-container">
            <Button color="danger" onClick={() => deleteProduct(productIndex)}>
              Remove Product
            </Button>
          </div>
        </>
      )}
      <div
        className={`product-groups-header${
          indexOpen === productIndex ? ' product-groups-header_open' : ''
        }`}
        onClick={() => onToggleCollapse(productIndex)}
      >
        {editMode && currentId === groupId ? (
          ' '
        ) : (
          <span className="product-name">{product.name}</span>
        )}
      </div>
      <Collapse isOpen={indexOpen === productIndex}>
        <div className="collapse-content">
          <h5 className="product-item-title">Description:</h5>
          {editMode && currentId === groupId ? (
            <Input
              type="textarea"
              name="description"
              value={editData.products[productIndex].description}
              className="edit-description-product"
              placeholder="Please enter product description"
              onChange={e =>
                updateProductField(productIndex, e.currentTarget.name, e.currentTarget.value)
              }
            />
          ) : (
            <p className="description-product-block">
              {product.description.length ? product.description : 'No description'}
            </p>
          )}
          <br />
          <h5 className="product-item-title">Price:</h5>
          <Table className="price-list-table" bordered>
            <tbody>
              <tr>
                <td>Price</td>
                <td>
                  $
                  {editMode && currentId === groupId ? (
                    <Input
                      type="text"
                      value={editData.products[productIndex].price.toString().trim() || ''}
                      style={{ maxWidth: '125px', marginLeft: '5px' }}
                      name="price"
                      onChange={e => onChangePrice(e, product.price)}
                      onBlur={e => onBlurPrice(e, product.price)}
                      className="edit-price-product"
                    />
                  ) : (
                    product.price
                  )}
                </td>
              </tr>
            </tbody>
          </Table>
        </div>
      </Collapse>
    </div>
  );
};

export default Product;
